import { configureStore } from '@reduxjs/toolkit'
import boxSetsReducer from './slices/boxSetsSlice'
import odooReducer from './slices/odooSlice'

export const store = configureStore({
  reducer: {
    boxSets: boxSetsReducer,
    odoo: odooReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
